import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";
import AgGridPaginatedTable from "../../components/AgGridPaginatedTable";
import { Link, useParams } from "react-router-dom";
import { Box, Grid, Typography, Button, Paper, TextField } from "@mui/material";
import { uploadFilesTable as tableDef } from "../../config/grid-column-defs";
import {
  getUploadFilesDataFromDataBase,
} from "../../api/upload-files";

export default function UploadFiles() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [dateSortAscending, setDateSortAscending] = useState(true);
  const [fileName, setFileName] = useState("");
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  function refreshTable() {
    setTableRefreshCount((prev) => prev + 1);
  }
  async function getUploadFilesTableData(limit, offset) {
    try {
      const { data } = await getUploadFilesDataFromDataBase(user?.token, {
        filename: fileName,
        // sortBy: "desc",
        limit,
        offset,
      });
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      // setLoading(false)
    }
  }
  useEffect(() => {
    refreshTable();
  }, [fileName]);
  function onSortChanged() {
    setDateSortAscending((previous) => !previous);
    setTableRefreshCount((prev) => prev + 1);
  }

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        pb={2}
      >
        <Typography component="h5" fontWeight={500} className="pageHeading1">
          {"Upload Files"}
        </Typography>

        <Link to="/upload-files">
          <Button size="small"className="backBtn">
            Upload File
          </Button>
        </Link>
      </Box>
      <Box className="filter-box">
        <Grid container>
          <Grid item md={3} sm={3} xs={12}>
            <TextField
              id="outlined-basic"
              size="small"
              label="Filename"
              variant="outlined"
              value={fileName}
              onChange={(e) => {
                setFileName(e.target.value);
                // getUploadFilesTableData();
              }}
            />
          </Grid>
        </Grid>
      </Box>
      <Paper elevation={3}>
        <AgGridPaginatedTable
          getTableRows={getUploadFilesTableData}
          columns={tableDef}
          perPage={10}
          refreshCounter={tableRefreshCount}
          onSortChanged={onSortChanged}
        />
      </Paper>
    </>
  );
}
